
import { Observable, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ColorERP } from 'src/app/model/ColorERP';
import { TransacNeo } from 'src/app/model/transacNeo';




const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json'
  })
  };



  @Injectable({
    providedIn: 'root'
  })
  export class NeoLinkService {
    private url : string = `${environment.HOST}`;

  //private url : string = "api_erp";
    constructor(
        private http : HttpClient,
        private router : Router
      ) { }

      
   

      

      pagarNeoLink(datos?: JSON, merchantuser?:any,merchantpassword?:any,ipPublica?:any,systraceno?:any,terminal?:any,afiliacion?:any,tajeta?:any,vencimiento?:any,ccv?:any,total?:any,cardtype?:any,idPedido?:any,formatoTarjeta?:any,nombreTarjeta?:any,valorCompra?:any,cuota?:any) {

        const headers = new HttpHeaders()
        .append( 'Content-Type',  'application/json')
        .append('MerchantUser', merchantuser)
        .append('ShopperIP', ipPublica) // ip publica del cliente
        .append('MerchantPasswd', merchantpassword)
        .append('PaymentgwIP', '181.114.3.133')  // ip pasarela 190.149.69.135
        .append('MerchantServerIP', '95.216.212.58'); //ip del servidor backend 


        return this.http.post(`${this.url}/api/neonet/enviar/${systraceno}/${terminal}/${afiliacion}/${tajeta}/${vencimiento}/${ccv}/${total}/${cardtype}/${idPedido}/${formatoTarjeta}/${nombreTarjeta}/${valorCompra}/${cuota}`, datos,{headers});
      }

      anularNeoLink(datos?: JSON, merchantuser?:any,merchantpassword?:any,ipPublica?:any) {

        const headers = new HttpHeaders()
        .append( 'Content-Type',  'application/json')
        .append('MerchantUser', merchantuser)
        .append('ShopperIP', ipPublica) // ip publica del cliente
        .append('MerchantPasswd', merchantpassword)
        .append('PaymentgwIP', '190.149.69.135')  // ip pasarela 190.149.69.135
        .append('MerchantServerIP', '95.216.212.58'); //ip del servidor backend 


        return this.http.post(`${this.url}/api/neonet/anular`, datos,{headers});
      }

}